import styled from '@emotion/styled';
import { __t } from '../../i18n';
import { Flex, Text } from '../../styles';

const Container = styled(Flex)(({ theme }) => ({
  border: `solid 2px ${theme.palette.background[500][0]}`,
  borderRadius: theme.radius.default,
  lineHeight: theme.font.lineHeight.normal,
  [`${Flex}`]: {
    '& > p:last-of-type': {
      flexShrink: 0,
    },
  },
}));

const HorizontalLine = styled.div(({ theme }) => ({
  width: '100%',
  height: '2px',
  backgroundColor: theme.palette.background[500][0],
}));

type RemainingVotesProps = {
  group: {
    count?: number | null,
    total: number | null,
  },
  item: {
    count: number,
    total: number,
    title?: string,
  },
};

export default function RemainingVotes({ group, item }: RemainingVotesProps) {
  return (
    <Container
      direction="column"
      justify="space-around"
      px={2}
      mt={{ xs: 4, md: 0 }}
      ml={{ md: 1 }}
    >
      {group?.total
        ? (
          <>
            <Flex justify="space-between" my={1}>
              <Text>{__t('survey.remaining_votes_season')}</Text>
              <Text weight="bold" mr={1}>
                {__t('survey.remainig_votes.range', { count: group.count ? group.count : group.total, total: group.total })}
              </Text>
            </Flex>
            <HorizontalLine />
            <Flex justify="space-between" my={1}>
              <Text>{__t('survey.remaining_votes')} {item?.title}</Text>
              <Text weight="bold" mr={1}>
                {(group?.count ? Math.min(group.count, item.total) : item.total) - item.count} {__t('survey.vote')}
              </Text>
            </Flex>
          </>
        ) : (
          <Flex direction="column" justify="center" my={2}>
            <Text variant="body2" align="center" mb={2}>
              {__t('survey.remaining_votes')} {item?.title}
            </Text>
            <Text variant="body1" weight="bold" align="center">
              {__t('survey.remainig_votes.range', {
                count: item.count,
                total: group.count ? Math.min(group.count, item.total) : item.total,
              })}
            </Text>
          </Flex>
        )
      }
    </Container>
  );
}
